import { ReactNode, createContext } from 'react';

type ISeverity = 'success' | 'info' | 'warn' | 'error';

type ToastNotificationContextValue = {
  showToast: (toastInfo: {
    severity: ISeverity;
    detail: string | ReactNode;
  }) => void;
};

export const ToastNotificationContext = createContext<
  ToastNotificationContextValue | undefined
>(undefined);
